import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  channel: belongsTo('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  image: belongsTo('asset', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
});
